export default "__VITE_ASSET__CgpcpmjZ__"